import React from 'react'
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material'
import { SwapHoriz } from '@mui/icons-material'
import { IOrganization } from '../../Definitions'
import { OrganizationId } from '../../utils/OrganizationIds'

interface IOrganizationSwitcherProps {
  expanded: boolean
  currentOrganization?: IOrganization
  organizations: IOrganization[]
  switchOrganization: (org: IOrganization) => void
  isWorkflowAdmin: boolean
}

const OrganizationSwitcher: React.FC<IOrganizationSwitcherProps> = ({
  expanded,
  currentOrganization,
  organizations,
  switchOrganization,
  isWorkflowAdmin,
}) => {
  const availableOrganizations = organizations.filter(
    (org) => org.id === OrganizationId.Medical || org.id === OrganizationId.Surgical
  )

  if (!isWorkflowAdmin || !availableOrganizations || availableOrganizations.length < 2) {
    return null
  }

  const targetOrganization = availableOrganizations.find(
    (org) => org.id !== currentOrganization?.id
  )

  if (!targetOrganization) {
    return null
  }

  const handleClick = () => {
    switchOrganization(targetOrganization)
  }

  const getOrgDisplayName = (org: IOrganization) => {
    if (org.id === OrganizationId.Surgical) return 'Surgical'
    if (org.id === OrganizationId.Medical) return 'Medical'
    return org.name || 'Unknown'
  }

  const targetOrgName = getOrgDisplayName(targetOrganization)
  const tooltipText = expanded ? '' : `${targetOrgName}`

  return (
    <Tooltip title={tooltipText} placement="right">
      <ListItem
        disablePadding
        sx={{
          paddingTop: expanded ? 0 : 0.5,
          paddingBottom: expanded ? 0 : 0.5,
        }}
      >
        <ListItemButton
          onClick={handleClick}
          sx={{ justifyContent: expanded ? 'flex-start' : 'center' }}
        >
          <ListItemIcon
            sx={{
              minWidth: expanded ? 40 : 'auto',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <SwapHoriz />
          </ListItemIcon>
          {expanded && (
            <ListItemText
              primary={`Switch to ${targetOrgName}`}
              primaryTypographyProps={{
                noWrap: true,
                sx: {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                },
              }}
              sx={{ flex: 1, minWidth: 0 }}
            />
          )}
        </ListItemButton>
      </ListItem>
    </Tooltip>
  )
}

export default OrganizationSwitcher
